import { styled } from 'opensolar-ui'

const Container = styled('div', {name: 'ImagePlaceholder'})(() => ({
  position: 'relative',
  background: '#F6F6F6',
  width: '100%',
  height: '160px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

const ImagePlaceholder = () => {
  return (
    <Container>
      <img src={`${window.PUBLIC_URL}/images/component-image-placeholder.png`} />
    </Container>
  )
}

export default ImagePlaceholder
